import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperOverviewPlazaPage } from './shopper-overview-plaza';

@NgModule({
  declarations: [
    ShopperOverviewPlazaPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperOverviewPlazaPage),
    TranslateModule.forChild()
  ],
})
export class ShopperOverviewPlazaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-overview-plaza/shopper-overview-plaza.module.ts